import {
  addWorkoutExerciseAction,
  saveWorkoutAction,
  updateExerciseWorkoutExerciseAction
} from '@gymaholic/packages'
import getCurrentIdWorkoutSelect from '@gymaholic/packages/src/modules/workout/redux/selectors/get-current-id'
import Button from 'components/Button'
import { LoadingIcon } from 'components/Icon/icons/loading'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import useSelector from 'modules/component/utils/hooks/useSelector.js'
import runAfterDelayPromisifiedPerformanceUtil from 'modules/performance/run-after-delay-promisified/index.js'

const messages = defineMessages({
  add: {
    id: 'ExerciseHeaderRight.add',
    defaultMessage: 'Add'
  },
  replace: {
    id: 'ExerciseHeaderRight.replace',
    defaultMessage: 'Replace'
  }
})

const ANALYTICS_EVENT = {
  ADD_EXERCISE: 'ADD_EXERCISE',
  REPLACE_EXERCISE: 'REPLACE_EXERCISE'
}

const DELAY_BEFORE_SAVING_WORKOUT_IN_MS = 1000

/**
 * @param isReplacing
 * @param exerciseId
 * @param loading
 * @param setLoading
 * @param workoutExerciseId
 * @param navigateBackToOrigin
 * @returns {JSX.Element}
 * @constructor
 */
export default function ExerciseHeaderRight ({
  isReplacing,
  loading,
  setLoading,
  exerciseId,
  workoutExerciseId,
  navigateBackToOrigin
}) {
  const dispatch = useDispatch()
  const intl = useIntl()
  const workoutId = useSelector(getCurrentIdWorkoutSelect)

  const handleClickHeaderRight = () => {
    setLoading(true)

    const next = async () => {
      navigateBackToOrigin()
      await runAfterDelayPromisifiedPerformanceUtil({
        delay: DELAY_BEFORE_SAVING_WORKOUT_IN_MS
      })
      dispatch(saveWorkoutAction(workoutId))
    }

    if (isReplacing) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.REPLACE_EXERCISE)
      dispatch(
        updateExerciseWorkoutExerciseAction({
          id: workoutExerciseId,
          exerciseId
        })
      )
      next()
      return
    }

    logEventAnalyticsUtil(ANALYTICS_EVENT.ADD_EXERCISE)
    dispatch(addWorkoutExerciseAction())
    next()
  }

  let headerRightMessage
  if (isReplacing) {
    headerRightMessage = messages.replace
  } else {
    headerRightMessage = messages.add
  }

  return (

    <View
      style={{
        width: '100px',
        textAlign: 'end'
      }}
    >
      <Button
        disabled={loading}
        onClick={handleClickHeaderRight}
        d='flex'
        style={{
          width: 'unset',
          height: 'unset',
          maxWidth: 'unset',
          maxHeight: 'unset',
          justifyContent: 'flex-end'
        }}
      >
        <Text
          fs='1.2em'
        >
          {
            loading
              ? (
                <LoadingIcon
                  stroke='black'
                  style={{
                    width: '20px',
                    height: '20px'
                  }}
                />
                )
              : formatMessageIntlUtil(intl, headerRightMessage)
          }
        </Text>
      </Button>
    </View>
  )
}
